import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CareService} from 'src/app/admin/admin-services/care.service';
import {finalize, first} from 'rxjs/operators';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder} from '@angular/forms';
import {ProcessService} from 'src/app/services/user-services/process.service';
import {AlertService} from 'src/app/services/alert.service';
import {ProcessSharedService} from 'src/app/services/process-shared.service';
import {AdminProcessService} from 'src/app/admin/admin-services/admin-process.service';
import {document} from 'ngx-bootstrap/utils';
import {MatTabGroup, MatTabsModule} from '@angular/material/tabs';
import {BasicInformationsComponent} from '../../../../components/basic-informations/basic-informations.component';
import {BtnStickyBotComponent} from '../../../../../shared/components/ux/buttons/btn-sticky-bot/btn-sticky-bot.component';
import {OneValueFormInputComponent} from '../../../../../shared/components/ux/inputs/one-value-form-input/one-value-form-input.component';
import {InclusionsManagementComponent} from '../../../../../shared/components/ux/inclusions-management/inclusions-management.component';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatExpansionModule} from '@angular/material/expansion';
import {DatePipe, NgClass, NgFor, NgIf} from '@angular/common';
import {CheckFormErrorDirective} from '../../../../../directives/checkFormError.directive';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MatCheckbox} from '@angular/material/checkbox';
import {PropertiesService} from '../../../../admin-services/properties.service';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss'],
  standalone: true,
  imports: [NgIf, MatTabsModule, FormsModule, ReactiveFormsModule, MatExpansionModule, MatFormFieldModule, MatInputModule, NgxIntlTelInputModule, NgFor, InclusionsManagementComponent, NgClass, OneValueFormInputComponent, BtnStickyBotComponent, BasicInformationsComponent, DatePipe, CheckFormErrorDirective, TranslateModule, MatCheckbox]
})
export class PartnerComponent implements OnInit, AfterViewInit {

  public partner;
  private partnerId;
  public faqs;
  public isLoading = false;
  public scheduleForm;
  public isFormSubmit = false;
  public charges; //***************** Liste des charges, à prendre en compte */
  public amenities; //***************** Liste des amenities, à prendre en compte */
  public datas: any = {id: null};
  public selectedAmenities = [];
  public selectedFaqs = [];
  public chargesArray: any[] = [];

  public isLoadingOnSubmit = false;

  // Menu
  @ViewChild('matTabGroup') matTabGroup: MatTabGroup;
  private ID_ARRAY: string[] = ['hours', 'charges', 'caracteristics', 'faq', 'cities'];
  private noAutoScroll = false;

  public showWarningModale: boolean = true;
  public modaleStatus: 'preSubmit' | 'submit' | 'ended' = 'preSubmit';
  public disabledWarningModale;
  public nbUpdated: number;


  constructor(
    private route: ActivatedRoute,
    private careService: CareService,
    private processService: ProcessService,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private processSharedService: ProcessSharedService,
    private adminProcessService: AdminProcessService,
    private modalService: NgbModal,
    private carePropertiesService: PropertiesService,
  ) {
    this.scheduleForm = this.formBuilder.group({
      mondayAm: '',
      mondayPm: '',
      tuesdayAm: '',
      tuesdayPm: '',
      wednesdayAm: '',
      wednesdayPm: '',
      thursdayAm: '',
      thursdayPm: '',
      fridayAm: '',
      fridayPm: '',
      saturdayAm: '',
      saturdayPm: '',
      sundayAm: '',
      sundayPm: ''
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.partnerId = this.route.snapshot.paramMap.get('id');
    this.careService.getPartner(this.partnerId).pipe(first()).subscribe(data => {
      this.partner = data;

      // organise les villes par ordre alphabétique
      data.cities.sort((a, b) => a.name > b.name ? 1 : -1);

      this.adminProcessService.getCharges().subscribe(data => {
        this.charges = data;
        this.charges.forEach(element =>
          this.chargesArray.push({name: element, icon: '', included: false, canBeChanged: true})
        );
        this.chargesArray.forEach(element => {
          let check = -1;
          if (this.partner.includedCharges) {
            check = this.partner.includedCharges.indexOf(element.name);
          } else {
            this.partner.includedCharges = [];
          }
          if (check >= 0) {
            element.canBeChanged = false;
            element.included = true;
          }
        });
      });

      this.isLoading = false;
      if (this.partner.checkInSchedule) {
        this.scheduleForm.controls.mondayAm.setValue(this.partner.checkInSchedule.mondayAm);
        this.scheduleForm.controls.mondayPm.setValue(this.partner.checkInSchedule.mondayPm);
        this.scheduleForm.controls.tuesdayAm.setValue(this.partner.checkInSchedule.tuesdayAm);
        this.scheduleForm.controls.tuesdayPm.setValue(this.partner.checkInSchedule.tuesdayPm);
        this.scheduleForm.controls.wednesdayAm.setValue(this.partner.checkInSchedule.wednesdayAm);
        this.scheduleForm.controls.wednesdayPm.setValue(this.partner.checkInSchedule.wednesdayPm);
        this.scheduleForm.controls.thursdayAm.setValue(this.partner.checkInSchedule.thursdayAm);
        this.scheduleForm.controls.thursdayPm.setValue(this.partner.checkInSchedule.thursdayPm);
        this.scheduleForm.controls.fridayAm.setValue(this.partner.checkInSchedule.fridayAm);
        this.scheduleForm.controls.fridayPm.setValue(this.partner.checkInSchedule.fridayPm);
        this.scheduleForm.controls.saturdayAm.setValue(this.partner.checkInSchedule.saturdayAm);
        this.scheduleForm.controls.saturdayPm.setValue(this.partner.checkInSchedule.saturdayPm);
        this.scheduleForm.controls.sundayAm.setValue(this.partner.checkInSchedule.sundayAm);
        this.scheduleForm.controls.sundayPm.setValue(this.partner.checkInSchedule.sundayPm);
      }
      this.selectedAmenities = this.partner.amenities;
      this.selectedFaqs = this.partner.faq;
    });

    this.processSharedService.getAmenities().subscribe(data => {
      this.amenities = data;
    });

    this.adminProcessService.getFaq().subscribe(data => {
      this.faqs = data;
    });

    if (localStorage.getItem('admin-disableConfigWarning')) {
      this.showWarningModale = false;
    }

  }


  ngAfterViewInit() {
  }

  // Rend le menu sur la partie gauche fonctionnel
  public tabChanges(tab_id: number) {
    const element = document.getElementById(this.ID_ARRAY[tab_id]);
    let top: number;
    if (element && element.offsetTop) {
      top = element.offsetTop - 48;
    }
    const mainElement = document.getElementsByClassName('page_content')[0];
    if (!this.noAutoScroll) {
      mainElement.scrollTo({top: top, behavior: 'smooth'});
    }
    this.noAutoScroll = false;
  }


  public updateItemCharges(event, item): void {
    if (event) {
      this.partner.includedCharges.push(item.name);
    } else {
      const index = this.partner.includedCharges.indexOf(item.name);
      this.partner.includedCharges.splice(index, 1);
    }
  }

  //@todo Update les amenities
  public updateArray(datasArray, id): void {
    const check = datasArray.indexOf(id);
    if (check < 0) {
      datasArray.push(id);
    } else {
      datasArray.splice(check, 1);
    }
  }

  public isChecked(array, id) {
    if (!array || array.indexOf(id) < 0) {
      return false;
    }
    return true;

  }

  //@todo all
  public submit(): void {
    this.isLoadingOnSubmit = true;
    this.datas.id = this.partnerId;
    this.datas.schedule = this.scheduleForm.value;
    this.datas.selectedAmenities = this.selectedAmenities;
    this.datas.selectedFaqs = this.selectedFaqs;
    this.datas.includedCharges = this.partner.includedCharges;
    this.datas.configuration = this.partner.configuration;
    this.careService.updatePartner(this.datas).pipe(first(), finalize(() => {
      this.isLoadingOnSubmit = false;
    })).subscribe({
      next: (response: any) => {
        this.alertService.openSnackBar('Partner updated.', 'snack-success');
      },
      error: (err) => {
        this.alertService.openSnackBar(err, 'snack-error');
      }
    });
  }

  getSubCities(cityId) {
    const array = this.partner.allCities.filter(c => c.cityGroup == cityId);
    return array.sort((a, b) => a.name.localeCompare(b.name));
  }

  getTotalAccommodations(cityId) {
    const subCityArray = this.getSubCities(cityId);
    let sum = 0;
    subCityArray.forEach(i => {
      sum = sum + this.partner.cityCount[i.id];
    });
    return sum;
  }

  getConfig(field, cityId) {
    return this.partner.configuration && this.partner.configuration[field] && this.partner.configuration[field][cityId] ? this.partner.configuration[field][cityId] : 0;
  }

  public openModale(modal): void {
    if (this.showWarningModale) {
      this.modalService.open(modal, {size: 'sm', centered: true});
    } else {
      this.updatePartner();
    }
  }

  public updatePartner(): void {
    this.modaleStatus = 'submit';
    if (this.disabledWarningModale) {
      localStorage.setItem('admin-disableConfigWarning', 'true');
      this.showWarningModale = false;
    }
    this.carePropertiesService.updatePartnerProperties(this.partnerId).subscribe({
      next: (response: any) => {
        this.modaleStatus = 'ended';
        const r = JSON.parse(response.datas);
        this.nbUpdated = r.updated;
        if (!this.showWarningModale) {
          this.alertService.openSnackBar(this.nbUpdated + ' Logements mis à jour', 'snack-success');
        }
      },
      error: (error) => {
        if (!this.showWarningModale) {
          this.alertService.openSnackBar('Problème lors de la maj des logements', 'snack-error');
        }
        console.log(error);
        this.modaleStatus = 'ended';
      }
    });
  }

  changeConfiguration(type: string, id: number, e): void {
    this.partner.configuration[type][id] = e;
    const city = this.partner.allCities.find(x => x.id === id);
    if (city.isHousingCity) {
      const subCities = this.partner.allCities.filter(c => c.cityGroup === id);
      if (subCities && subCities.length > 0) {
        subCities.forEach(c => {
          this.partner.configuration[type][c.id] = e;
        });
      }
    }
  }

}
